const getWeekDay = (date) => {
  // Returns number of the week day (0-6 for mon-sun)
  return date.getDay();
};
const getMonth = (date) => {
  return date.getMonth();
};
const getDate = (date) => {
  return date.getDate();
};
const getMonthName = (date, language) => {
  return date.toLocaleString(language, { month: "long" });
};
const getYear = (date) => {
  return date.getFullYear();
};
const getMonthNumDays = (month) => {
  return new Date(new Date().getFullYear(), month, 0).getDate();
};
/**
 * Compares dates. Checks if date1 is before date2.
 * @param date1 Date
 * @param date2 Date
 */
const isBeforeDate = (date1, date2) => {
  const newDate1 = new Date(getYear(date1), getMonth(date1), getDate(date1), 0, 0, 0);
  const newDate2 = new Date(getYear(date2), getMonth(date2), getDate(date2), 0, 0, 0);
  return newDate2 < newDate1;
};
/**
 * Compares dates. Checks if date2 is after date1.
 * @param date1 Date
 * @param date2 Date
 */
const isAfterDate = (date1, date2) => {
  const newDate1 = new Date(getYear(date1), getMonth(date1), getDate(date1), 0, 0, 0);
  const newDate2 = new Date(getYear(date2), getMonth(date2), getDate(date2), 0, 0, 0);
  return newDate2 > newDate1;
};
const extractRangeDate = (dateValue) => {
  const date = dateValue.split("/")[0].length > 1 ? dateValue.split("/")[0] : dateValue;
  const rangeDate = dateValue.split("/")[1];
  return {
    date,
    rangeDate,
  };
};
const isDateBetweenRange = (date, startDate, endDate) => {
  return isAfterDate(startDate, date) && isBeforeDate(endDate, date);
};

export { isAfterDate as a, isDateBetweenRange as b, getMonth as c, getWeekDay as d, extractRangeDate as e, getMonthName as f, getMonthNumDays as g, getYear as h, isBeforeDate as i };
